import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setFieldSettingsMinimumOrMaximumFractionDigitsField: YJSChangeHandler<
  DatabaseChangeType.SET_FIELD_SETTINGS_MINIMUM_OR_MAXIMUM_FRACTION_DIGITS_FIELD
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    if (change.changeType === 'decimalPlaces') {
      db.fieldsById[change.fieldId].customNumberFormat.decimalPlaces = change.newValue;
    } else if (change.changeType === 'minimumFractionDigits') {
      db.fieldsById[change.fieldId].customNumberFormat.minFractionDigits =
        change.newValue;
    } else if (change.changeType === 'maximumFractionDigits') {
      db.fieldsById[change.fieldId].customNumberFormat.maxFractionDigits =
        change.newValue;
    }
  });
};
